import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[kwSetSlideContainerHeight]'
})
export class SetSlideContainerHeightDirective implements AfterViewInit {
  containerHeight:number = 0;
  constructor(private el:ElementRef) { }
  
  ngAfterViewInit(): void {
    let host = <HTMLElement>this.el.nativeElement;
    let imageContainers = host.getElementsByClassName("image-wrapper");
    for(let i=0;i<imageContainers.length;i++){
      let imageContainer = <HTMLElement>imageContainers[i];
      if(imageContainer.offsetHeight > this.containerHeight){
        this.containerHeight = imageContainer.offsetHeight;
      }
    }
    host.style.setProperty("height",this.containerHeight+"px")
  }

}
